import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Alert,
} from "@mui/material";
import TADialog from "./components/TADialog";
import StudyDropDown from "../../common/components/StudyDropDown";
import { useGetTAsQuery } from "../../api/useGetTA";
import TAEditDialog from "./components/TAEditDialog";
import { useDeleteTAQuery } from "../../api/useDeleteTA";

const AdminTAPage = () => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [selectedStudy, setSelectedStudy] = React.useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [editData, setEditData] = useState(null);
  const { mutate: deleteTA } = useDeleteTAQuery();
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openEditModal = () => setIsEditModalOpen(true);
  const closeEditModal = () => {
    setEditData(null);
    setIsEditModalOpen(false);
  };

  const {
    data: taList,
    isLoading,
    isError,
    error,
  } = useGetTAsQuery({ studyId: selectedStudy._id, keyword: searchTerm });

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleEditClick = (user) => {
    setEditData(user);
    openEditModal();
  };

  const handleStudyChange = (event) => {
    setSelectedStudy(event.target.value);
  };
  const handleNewUser = () => {
    setEditData(null);
    openModal();
  };

  const handleDeleteClick = (userId) => {
    if (window.confirm("삭제하시겠습니까?")) {
      deleteTA(userId);
    }
  };

  if (isLoading) {
    return <div>loading...</div>;
  }
  if (isError) {
    setErrorMessage(error.response.data.message);
  }
  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <StudyDropDown
            selectedStudy={selectedStudy}
            handleStudyChange={handleStudyChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="이름 또는 이메일 검색"
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Grid>

        <Grid item sm={2} xs={12}>
          <Button variant="contained" fullWidth onClick={handleNewUser}>
            TA 추가
          </Button>
        </Grid>
      </Grid>
      {isError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      ) : (
        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>이름</TableCell>
                <TableCell>이메일</TableCell>

                <TableCell>스터디 리스트</TableCell>
                <TableCell>활동여부</TableCell>

                <TableCell>수정/삭제</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {taList.map((ta) => (
                <TableRow key={ta._id}>
                  <TableCell>{ta.userId.name}</TableCell>
                  <TableCell>{ta.userId.email}</TableCell>

                  <TableCell>
                    {ta.studyId.map((study) => study.title).join(", ")}
                  </TableCell>
                  <TableCell>{ta.isValid ? "활동중" : "활동안함"}</TableCell>

                  <TableCell>
                    <Button size="small" onClick={() => handleEditClick(ta)}>
                      수정
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleDeleteClick(ta._id)}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <TADialog isModalOpen={isModalOpen} closeModal={closeModal} />
      <TAEditDialog
        isModalOpen={isEditModalOpen}
        closeModal={closeEditModal}
        data={editData}
      />
    </Box>
  );
};

export default AdminTAPage;
